module.exports = __webpack_public_path__ + "static/media/pause.2e0ef420.png";